<template>
  <div class="content background1" style="display: flex">
    <div class="tableBox9" v-if="!qrCodeShow">
      <div class="tableMes">
        <div class="table">
          <el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
            <!--						<el-tab-pane :label="$t('label_429')" name="first">-->
            <!--							<template>-->
            <!--								<tree :dataTree="treeData"  :treeType="0" @getDeviceMes="getDeviceMes"></tree>-->
            <!--							</template>-->
            <!--						</el-tab-pane>-->
            <el-tab-pane :label="this.$t('label_161')" name="second">
              <template>
                <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="right-showbtn" @click="showBtn">
      <div class="right-showbtn-qrcode-background">
        <i v-if="qrCodeShow" class="el-icon-arrow-right"
           style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
        <i v-if="!qrCodeShow" class="el-icon-arrow-left"
           style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
      </div>
    </div>
    <div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes">
            <p class="title">{{ deviceDetailMes.name }}</p>
            <div class="spotMes2Box" style="height: calc(100% - 90px); border: 0px;margin-top: 0px;">
              <div class="spotMesBox tab" style="height:100%;">
                <el-tabs v-model="activeNameSpot" @tab-click="handleClickSpot">
                  <el-tab-pane :label="$t('label_287')" name="spot">
                    <div class="allDiv">
                      <div class="warningleft">
                        <div class="modeldiv"></div>
                        <div class="modeldiv" v-for="(item,index) in modelList">
                          <span class="modelspan" @click="imgShow(index)">{{ item.title }}</span><img
                          @click="imgShow(index)" v-if="item.show"
                          :class="item.title==''?'modelImgarrows':'modelImg'" :src="item.imgtrue"/>
                          <img @click="imgShow(index)" v-if="!(item.show)"
                               :class="item.title==''?'modelImgarrows':'modelImg'" :src="item.imgfalse"/>
                        </div>
                        <div class="modeldiv"></div>
                      </div>
                      <div class="warningright">
                        <div class="warningBody">
                          <div class="warningBodyLeftDiv">
                            <div :id="('warningBodyLeftDivShowSpot'+index)"
                                 @click="showTableData(index)" class="warningBodyLeftDivShow"
                                 v-for="(item,index) in tableData"
                                 v-if="tableData[index].valid==0">
                              <div class="delete el-icon-circle-close" v-if="index != 0"
                                   @click="deleteTable(index)"></div>
                              <div class="warningspan">{{ $t('label_856') }}{{ level[index] }}{{ $t('label_565') }}
                              </div>
                            </div>
                            <!--                            <div class="warningBodyLeftDivAdd">-->
                            <!--                              <img @click="addWarning" class="Addimg" src="../../assets/img/add.png" />-->
                            <!--                            </div>-->
                          </div>
                          <div class="warningBodyRightDiv">
                            <span class="modelspan">{{ title }}</span>
                            <div class="RightDiv_top">
                              <span class="RightDiv_topspan">{{ $t('label_190') }}</span><br/>
                              <el-radio-group style="margin-top: 5px;" v-model="tableData[showTableDiv].frequency"
                                              @change="agreeChange">
                                <!--                                <el-radio label="0">-->
                                <!--                                  {{$t('label_531')}}-->
                                <!--                                  <el-input v-model="tableData[showTableDiv].time0" style="width: 60px;" :disabled="tableData[showTableDiv].frequency!='0'"></el-input>-->
                                <!--                                  {{$t('label_395')}}-->
                                <!--                                </el-radio>-->
                                <el-radio label="1">
                                  <el-input v-model="tableData[showTableDiv].time1" style="width: 60px;"
                                            :disabled="tableData[showTableDiv].frequency!='1'"></el-input>
                                  {{ $t('label_192') }}
                                </el-radio>
                                <el-radio label="2">
                                  <span style="line-height: 40px">{{ $t('label_195') }}</span>
                                </el-radio>
<!--                                <el-radio label="3">-->
<!--                                  <span style="line-height: 40px">{{ $t('label_965') }}</span>-->
<!--                                </el-radio>-->
                              </el-radio-group>
                            </div>
                            <div class="RightDiv_table">
                              <div class="useradd">
                                <span class="useraddspan">{{ $t('label_199') }}</span><img @click="addGroup"
                                                                                           class="subtract"
                                                                                           src="../../assets/img/add.png"/>
                              </div>
                              <el-table :empty-text="$t('label_357')" ref="singleTable"
                                        :data="tableData[showTableDiv].listGroup" highlight-current-row border
                                        style="width: 100%; margin-top: 10px;"
                                        height="calc(100% - 40px)"
                                        :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                                <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'"
                                                 type="index" width="50">
                                </el-table-column>
                                <el-table-column prop="workerNumber" :label="$t('label_559')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="fullName" :label="$t('label_72')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="roleName" :label="$t('label_208')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="organizationName" :label="$t('label_567')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column fixed="right" :label="$t('label_203')" width="80" align="center">
                                  <template slot-scope="scope">
                                    <img @click="deleteRow(scope.$index, tableData[showTableDiv].listGroup)"
                                         class="subtract" src="../../assets/img/subtract.png"/>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                            <div class="RightDiv_button">
                              <div style="text-align: center;">
                                <button class="btn" @click="submit" v-if="MenuRoleList.indexOf('69')>=0">
                                  {{ $t('btn_39') }}
                                </button>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('label_217')" name="pro">
                    <div class="allDiv">
                      <div class="warningleft">
                        <div class="modeldiv"></div>
                        <div class="modeldiv" v-for="(item,index) in modelList">
                          <span class="modelspan" @click="imgShow(index)">{{ item.title }}</span><img
                          @click="imgShow(index)" v-if="item.show"
                          :class="item.title==''?'modelImgarrows':'modelImg'" :src="item.imgtrue"/>
                          <img @click="imgShow(index)" v-if="!(item.show)"
                               :class="item.title==''?'modelImgarrows':'modelImg'" :src="item.imgfalse"/>
                        </div>
                        <div class="modeldiv"></div>
                      </div>
                      <div class="warningright">
                        <div class="warningBody">
                          <div class="warningBodyLeftDiv">
                            <div :id="('warningBodyLeftDivShowPro'+index)" @click="showTableData(index)"
                                 class="warningBodyLeftDivShow" v-for="(item,index) in tableData"
                                 v-if="tableData[index].valid==0">
                              <div class="delete el-icon-circle-close" v-if="index != 0"
                                   @click="deleteTable(index)"></div>
                              <div class="warningspan"
                              >{{ $t('label_856') }}{{ level[index] }}{{ $t('label_565') }}
                              </div>
                            </div>
                            <!--                            <div class="warningBodyLeftDivAdd">-->
                            <!--                              <img @click="addWarning" class="Addimg" src="../../assets/img/add.png" />-->
                            <!--                            </div>-->
                          </div>
                          <div class="warningBodyRightDiv">
                            <span class="modelspan">{{ title }}</span>
                            <div class="RightDiv_top">
                              <span class="RightDiv_topspan">{{ $t('label_190') }}</span><br/>
                                <!--                                <el-radio label="0">-->
                                <!--                                  {{$t('label_531')}}-->
                                <!--                                  <el-input v-model="tableData[showTableDiv].time0" style="width: 60px;" :disabled="tableData[showTableDiv].frequency!='0'"></el-input>-->
                                <!--                                  {{$t('label_395')}}-->
                                <!--                                </el-radio>-->
                                <template v-if="modelList[0].show">
                                  <el-radio-group style="margin-top: 5px;" v-model="tableData[showTableDiv].frequency"
                                                  @change="agreeChange">
                                  <el-radio label="1">
                                    <el-input v-model="tableData[showTableDiv].time1" style="width: 60px;" :disabled="tableData[showTableDiv].frequency!='1'"></el-input>
                                    {{$t('label_192')}}
                                  </el-radio>
                                  <el-radio label="2">
                                    <span style="line-height: 40px">{{$t('label_195')}}</span>
                                  </el-radio>
                              </el-radio-group>
                                </template>
                              <template v-else>
                                <span style="line-height: 40px">{{ $t('label_965') }}</span>
                              </template>
<!--                              <span style="line-height: 40px">{{ $t('label_965') }}</span>-->
                            </div>
                            <div class="RightDiv_table">
                              <div class="useradd">
                                <span class="useraddspan">{{ $t('label_199') }}</span><img @click="addGroup"
                                                                                           class="subtract"
                                                                                           src="../../assets/img/add.png"/>
                              </div>
                              <el-table :empty-text="$t('label_357')" ref="singleTable"
                                        :data="tableData[showTableDiv].listGroup" highlight-current-row border
                                        style="width: 100%;height:calc(100% - 40px); margin-top: 10px;"
                                        :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                                <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'"
                                                 type="index" width="50">
                                </el-table-column>
                                <el-table-column prop="workerNumber" :label="$t('label_559')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="fullName" :label="$t('label_72')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="roleName" :label="$t('label_208')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="organizationName" :label="$t('label_567')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column fixed="right" :label="$t('label_203')" width="80" align="center">
                                  <template slot-scope="scope">
                                    <img @click="deleteRow(scope.$index, tableData[showTableDiv].listGroup)"
                                         class="subtract" src="../../assets/img/subtract.png"/>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                            <div class="RightDiv_button">
                              <div style="text-align: center;">
                                <button class="btn" @click="submit" v-if="MenuRoleList.indexOf('69')>=0">
                                  {{ $t('btn_39') }}
                                </button>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('label_229')" name="xun">
                    <div class="allDiv">
                      <div class="warningleft">
                        <div class="modeldiv"></div>
                        <div class="modeldiv" v-for="(item,index) in modelList">
                          <span class="modelspan" @click="imgShow(index)">{{ item.title }}</span>
                          <img @click="imgShow(index)" v-if="item.show"
                               :class="item.title==''?'modelImgarrows':'modelImg'" :src="item.imgtrue"/>
                          <img @click="imgShow(index)" v-if="!(item.show)"
                               :class="item.title==''?'modelImgarrows':'modelImg'" :src="item.imgfalse"/>
                        </div>
                        <div class="modeldiv"></div>
                      </div>
                      <div class="warningright">
                        <div class="warningBody">
                          <div class="warningBodyLeftDiv">
                            <div :id="('warningBodyLeftDivShowXun'+index)" @click="showTableData(index)"
                                 class="warningBodyLeftDivShow" v-for="(item,index) in tableData"
                                 v-if="tableData[index].valid==0">
                              <div class="delete el-icon-circle-close" v-if="index != 0"
                                   @click="deleteTable(index)"></div>
                              <div class="warningspan"
                              >{{ $t('label_856') }}{{ level[index] }}{{ $t('label_565') }}
                              </div>
                            </div>
                            <!--                            <div class="warningBodyLeftDivAdd">-->
                            <!--                              <img @click="addWarning" class="Addimg" src="../../assets/img/add.png" />-->
                            <!--                            </div>-->
                          </div>
                          <div class="warningBodyRightDiv">
                            <span class="modelspan">{{ title }}</span>
                            <div class="RightDiv_top">
                              <span class="RightDiv_topspan">{{ $t('label_190') }}</span><br/>
                              <!--<el-radio-group style="margin-top: 5px;" v-model="tableData[showTableDiv].frequency"
                                              @change="agreeChange">
&lt;!&ndash;                                                                <el-radio label="0">
                                                                  {{$t('label_531')}}
                                                                  <el-input v-model="tableData[showTableDiv].time0" style="width: 60px;" :disabled="tableData[showTableDiv].frequency!='0'"></el-input>
                                                                  {{$t('label_395')}}
                                                                </el-radio>
                                                                <el-radio label="1">
                                                                  <el-input v-model="tableData[showTableDiv].time1" style="width: 60px;" :disabled="tableData[showTableDiv].frequency!='1'"></el-input>
                                                                  {{$t('label_192')}}
                                                                </el-radio>
                                                                <el-radio label="2">
                                                                  <span style="line-height: 40px">{{$t('label_195')}}</span>
                                                                </el-radio>&ndash;&gt;
                                <el-radio label="3">
                                  <span style="line-height: 40px">{{ $t('label_965') }}</span>
                                </el-radio>
                              </el-radio-group>-->
                              <template v-if="modelList[0].show">
                                <el-radio-group style="margin-top: 5px;" v-model="tableData[showTableDiv].frequency"
                                                @change="agreeChange">
                                  <el-radio label="1">
                                    <el-input v-model="tableData[showTableDiv].time1" style="width: 60px;" :disabled="tableData[showTableDiv].frequency!='1'"></el-input>
                                    {{$t('label_192')}}
                                  </el-radio>
                                  <el-radio label="2">
                                    <span style="line-height: 40px">{{$t('label_195')}}</span>
                                  </el-radio>
                                </el-radio-group>
                              </template>
                              <template v-else>
                                <span style="line-height: 40px">{{ $t('label_965') }}</span>
                              </template>
                            </div>
                            <div class="RightDiv_table">
                              <div class="useradd">
                                <span class="useraddspan">{{ $t('label_199') }}</span><img @click="addGroup"
                                                                                           class="subtract"
                                                                                           src="../../assets/img/add.png"/>
                              </div>
                              <el-table :empty-text="$t('label_357')" ref="singleTable"
                                        :data="tableData[showTableDiv].listGroup" highlight-current-row border
                                        style="width: 100%;height:calc(100% - 40px); margin-top: 10px;"
                                        :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                                <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'"
                                                 type="index" width="50">
                                </el-table-column>
                                <el-table-column prop="workerNumber" :label="$t('label_559')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="fullName" :label="$t('label_72')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="roleName" :label="$t('label_208')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="organizationName" :label="$t('label_567')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column fixed="right" :label="$t('label_203')" width="80" align="center">
                                  <template slot-scope="scope">
                                    <img @click="deleteRow(scope.$index, tableData[showTableDiv].listGroup)"
                                         class="subtract" src="../../assets/img/subtract.png"/>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                            <div class="RightDiv_button">
                              <div style="text-align: center;">
                                <button class="btn" @click="submit" v-if="MenuRoleList.indexOf('69')>=0">
                                  {{ $t('btn_39') }}
                                </button>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('label_692')" name="bao">
                    <div class="allDiv">
                      <div class="warningleft">
                        <div class="modeldiv"></div>
                        <div class="modeldiv" v-for="(item,index) in modelList">
                          <span class="modelspan" @click="imgShow(index)">{{ item.title }}</span><img
                          @click="imgShow(index)" v-if="item.show"
                          :class="item.title==''?'modelImgarrows':'modelImg'" :src="item.imgtrue"/>
                          <img @click="imgShow(index)" v-if="!(item.show)"
                               :class="item.title==''?'modelImgarrows':'modelImg'" :src="item.imgfalse"/>
                        </div>
                        <div class="modeldiv"></div>
                      </div>
                      <div class="warningright">
                        <div class="warningBody">
                          <div class="warningBodyLeftDiv">
                            <div :id="('warningBodyLeftDivShowBao'+index)" class="warningBodyLeftDivShow"
                                 v-for="(item,index) in tableData" @click="showTableData(index)"
                                 v-if="tableData[index].valid==0">
                              <div class="delete el-icon-circle-close" v-if="index != 0"
                                   @click="deleteTable(index)"></div>
                              <div class="warningspan">{{ $t('label_856') }}{{ level[index] }}{{ $t('label_565') }}
                              </div>
                            </div>
                            <!--                            <div class="warningBodyLeftDivAdd" >-->
                            <!--                              <img @click="addWarning" class="Addimg" src="../../assets/img/add.png" />-->
                            <!--                            </div>-->
                          </div>
                          <div class="warningBodyRightDiv">
                            <span class="modelspan">{{ title }}</span>
                            <div class="RightDiv_top">
                              <span class="RightDiv_topspan">{{ $t('label_190') }}</span><br/>
<!--                              <el-radio-group style="margin-top: 5px;" v-model="tableData[showTableDiv].frequency"
                                              @change="agreeChange">
                                                                <el-radio label="0">
                                                                  {{$t('label_531')}}
                                                                  <el-input v-model="tableData[showTableDiv].time0" style="width: 60px;" :disabled="tableData[showTableDiv].frequency!='0'"></el-input>
                                                                  {{$t('label_395')}}
                                                                </el-radio>
                                                                <el-radio label="1">
                                                                  <el-input v-model="tableData[showTableDiv].time1" style="width: 60px;" :disabled="tableData[showTableDiv].frequency!='1'"></el-input>
                                                                  {{$t('label_192')}}
                                                                </el-radio>
                                                                <el-radio label="2">
                                                                  <span style="line-height: 40px">{{$t('label_195')}}</span>
                                                                </el-radio>
                                <el-radio label="3">
                                  <span style="line-height: 40px">{{ $t('label_965') }}</span>
                                </el-radio>
                              </el-radio-group>-->
                              <template v-if="modelList[0].show">
                                <el-radio-group style="margin-top: 5px;" v-model="tableData[showTableDiv].frequency"
                                                @change="agreeChange">
                                  <el-radio label="1">
                                    <el-input v-model="tableData[showTableDiv].time1" style="width: 60px;" :disabled="tableData[showTableDiv].frequency!='1'"></el-input>
                                    {{$t('label_192')}}
                                  </el-radio>
                                  <el-radio label="2">
                                    <span style="line-height: 40px">{{$t('label_195')}}</span>
                                  </el-radio>
                                </el-radio-group>
                              </template>
                              <template v-else>
                                <span style="line-height: 40px">{{ $t('label_965') }}</span>
                              </template>
                            </div>
                            <div class="RightDiv_table">
                              <div class="useradd">
                                <span class="useraddspan">{{ $t('label_199') }}</span><img @click="addGroup"
                                                                                           class="subtract"
                                                                                           src="../../assets/img/add.png"/>
                              </div>
                              <el-table :empty-text="$t('label_357')" ref="singleTable"
                                        :data="tableData[showTableDiv].listGroup" highlight-current-row border
                                        style="width: 100%;height:calc(100% - 40px); margin-top: 10px;"
                                        :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                                <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'"
                                                 type="index" width="50">
                                </el-table-column>
                                <el-table-column prop="workerNumber" :label="$t('label_559')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="fullName" :label="$t('label_72')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="roleName" :label="$t('label_208')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column prop="organizationName" :label="$t('label_567')" align="left"
                                                 header-align="center"></el-table-column>
                                <el-table-column fixed="right" :label="$t('label_203')" width="80" align="center">
                                  <template slot-scope="scope">
                                    <img @click="deleteRow(scope.$index, tableData[showTableDiv].listGroup)"
                                         class="subtract" src="../../assets/img/subtract.png"/>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                            <div class="RightDiv_button">
                              <div style="text-align: center;">
                                <button class="btn" @click="submit" v-if="MenuRoleList.indexOf('69')>=0">
                                  {{ $t('btn_39') }}
                                </button>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('label_949')" name="email">
                    <div class="allDiv">
                      <div class="warningright1">
                        <div class="warningBody">
                          <div class="warningBodyRightDiv">
                            <div class="warningBodyRightDivTitle">{{ $t('label_950') }}</div>
                            <div class="warningBodyRightDivLabel">{{ $t('label_951') }}</div>
                            <div class="warningBodyRightDivInput">
                              <el-input v-model="ruleForm.host"></el-input>
                            </div>
                            <div class="warningBodyRightDivLabel">{{ $t('label_952') }}</div>
                            <div class="warningBodyRightDivInput">
                              <el-input v-model="ruleForm.port"></el-input>
                            </div>
                            <div class="warningBodyRightDivLabel">spssl</div>
                            <div class="warningBodyRightDivInput">
                              <el-checkbox-group v-model="ruleForm.spssl">
                                <el-checkbox true-label="1" false-label="0"><span
                                  style="font-size: 17px; font-weight: 600; line-height: 100%; vertical-align: -webkit-baseline-middle;">SSL</span>
                                </el-checkbox>
                              </el-checkbox-group>
                            </div>
                            <div class="warningBodyRightDivLabel">{{ $t('label_603') }}</div>
                            <div class="warningBodyRightDivInput">
                              <el-input v-model="ruleForm.userName"></el-input>
                            </div>
                            <div class="warningBodyRightDivLabel">{{ $t('label_606') }}</div>
                            <div class="warningBodyRightDivInput">
                              <el-input v-model="ruleForm.password"></el-input>
                            </div>
                            <div class="warningBodyRightDivLabel">{{ $t('label_953') }}</div>
                            <div class="warningBodyRightDivInput">
                              <el-input v-model="ruleForm.sender"></el-input>
                            </div>
                            <div class="RightDiv_button">
                              <div style="text-align: center; margin-top: 60px;">
                                <button class="btn" @click="submit1" v-if="MenuRoleList.indexOf('69')>=0">
                                  {{ $t('btn_39') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-loading="saveLoading" :visible.sync="dialogVisible" :title="$t('btn_14')" :before-close="dialogClose"
               append-to-body :close-on-click-modal='false'
               width="800px" top="10%" custom-class="dialogBoxWarning dialogBox">

      <div class="dialogBoxMes" style="padding:0 20px;">
        <el-row style="height: 30px;">
          <el-radio v-model="radioCheck" label="1">{{ $t('label_211') }}</el-radio>
          <el-radio v-model="radioCheck" label="2">{{ $t('label_214') }}</el-radio>
        </el-row>
        <el-row class="dialogMes" v-if="radioCheck=='1'">
          <el-col :span="1"></el-col>
          <el-col :span="3">{{ $t('label_720') }}</el-col>
          <el-col :span="20">
            <div class="treeNoChoose">
              <div class="selectSpot2" style='height: 100%;'>
                <el-tree :load="loadTree" @check-change="treeCheck" ref="tree" show-checkbox check-strictly lazy
                         :props="treeProps"
                         :accordion='true' node-key="id" :default-expanded-keys="['0']">
                  <div class="custom-tree-node" slot-scope="{node,data}">
                    <div class="title" style="width:250px;position:relative;display: flex">
                      <p
                        style="width: 150px;display: block;overflow: hidden;line-height: 30px;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
                        {{ data.name }}
                      </p>
                    </div>
                  </div>
                </el-tree>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="radioCheck=='2'">
          <div>
            <div style="width: calc(100% - 80px); float: left;">
              <span style="margin-left: 10px;">{{ $t('label_559') }}</span>
              <el-input v-model="searchUser.workerNumber" style="width: 180px;"></el-input>
              <span style="margin-left: 10px;">{{ $t('label_72') }}</span>
              <el-input v-model="searchUser.fullName" style="width: 180px;"></el-input>
              <!-- <span style="margin-left: 10px;">角色</span>
              <el-input v-model="searchUser.roleName" style="width: 110px;"></el-input>
              <span style="margin-left: 10px;">部门</span>
              <el-input v-model="searchUser.organizationName" style="width: 110px;"></el-input> -->
            </div>
            <div style="width: 80px; float: left;">
              <div class="chooseButton sendButton" @click="searchUserList" style="width: 80px; margin-top: 3px;">
                {{ $t('btn_2') }}
              </div>
            </div>
          </div>
        </el-row>
        <el-row class="dialogMes" v-if="radioCheck=='2'">
          <div style="width: 100%; ">
            <el-table :empty-text="$t('label_357')" ref="singleTable" :data="userList" highlight-current-row border
                      style="width: 100%; margin-top: 10px;"
                      height="calc(100% - 40px)"
                      :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
                      @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                               width="50">
              </el-table-column>
              <el-table-column prop="workerNumber" :label="$t('label_559')" align="left"></el-table-column>
              <el-table-column prop="fullName" :label="$t('label_72')" align="left"></el-table-column>
              <!-- <el-table-column prop="roleName" label="岗位" align="left"></el-table-column>
              <el-table-column prop="organizationName" label="部门" align="left"></el-table-column> -->
            </el-table>
          </div>

        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
				<div @click="save" class="chooseButton sendButton">{{ $t('btn_13') }}</div>
			</span>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import "@/assets/css/common/spot.css"
import Page from "@/components/common/page";
import TimePage from "@/assets/js/timePage/timePage.js";
import utils from '@/utils/utils'
import calendar from "@/components/list/calendar/calendar";
import tree from "@/components/list/tree/warnTree";
import file from "@/assets/js/file/file.js";
import checkItem from "@/components/list/displayPage/checkItemParam";
import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
import electronDocument from "@/components/list/displayPage/electronDocumentParam";
import partInfo from "@/components/list/displayPage/partInfoParam";
import common from "@/assets/js/common/common.js";
import organizationTabJs from "@/assets/js/system/organizationTab.js";
import menuTabJs from "@/assets/js/system/menuTab.js";
import userJs from "@/assets/js/user/user.js";

export default {
  name: 'spotResumePage',
  components: {
    Page,
    calendar,
    tree,
    checkItem,
    maintenanceItem,
    inspectionItem,
    electronDocument,
    partInfo
  },
  data() {
    return {
      saveLoading: false,
      radioCheck: '1',
      newRisk: {
        content: '',
        dictContentKey: '',
      },
      level: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      activeNameSpot: 'spot',
      deviceDetailMes: {
        type: 0,
        id: 0,
      },
      tableChooseInfo: {},
      dialogAdd: false,
      editName: this.$t('btn_14'),
      treeData: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: false,
        dataAll: true,
        funtoGetMes: '2'
      },
      treeData2: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: false,
        dataAll: false,
        funtoGetMes: '3'
      },
      tableData: [],
      MenuRoleList: [],
      parameterData: [],
      activeNameTree: 'second',
      riskID: '0',
      riskList: [],
      modelList: [{
        title: this.$t('label_277'),
        imgtrue: require('../../assets/img/circleGray.png'),
        imgfalse: require('../../assets/img/circleGreen.png'),
        show: false,
        node: 0,
      },
        {
          title: '',
          imgtrue: require('../../assets/img/arrowsGray.png'),
          imgfalse: require('../../assets/img/arrowsGreen.png'),
          show: false,
          node: 0,
        },
        {
          title: this.$t('label_415'),
          imgtrue: require('../../assets/img/circleGray.png'),
          imgfalse: require('../../assets/img/circleGreen.png'),
          show: true,
          node: 1,
        },
        {
          title: '',
          imgtrue: require('../../assets/img/arrowsGray.png'),
          imgfalse: require('../../assets/img/arrowsGreen.png'),
          show: true,
          node: 1,
        },
        {
          title: this.$t('label_424'),
          imgtrue: require('../../assets/img/circleGray.png'),
          imgfalse: require('../../assets/img/circleGreen.png'),
          show: true,
          node: 2,
        },
        {
          title: '',
          imgtrue: require('../../assets/img/arrowsGray.png'),
          imgfalse: require('../../assets/img/arrowsGreen.png'),
          show: true,
          node: 2,
        },
        {
          title: this.$t('label_434'),
          imgtrue: require('../../assets/img/circleGray.png'),
          imgfalse: require('../../assets/img/circleGreen.png'),
          show: true,
          node: 3,
        },
        {
          title: '',
          imgtrue: require('../../assets/img/arrowsGray.png'),
          imgfalse: require('../../assets/img/arrowsGreen.png'),
          show: true,
          node: 3,
        },
        {
          title: this.$t('label_444'),
          imgtrue: require('../../assets/img/circleGray.png'),
          imgfalse: require('../../assets/img/circleGreen.png'),
          show: true,
          node: 5,
        },
        {
          title: '',
          imgtrue: require('../../assets/img/arrowsGray.png'),
          imgfalse: require('../../assets/img/arrowsGreen.png'),
          show: true,
          node: 5,
        },
        {
          title: this.$t('label_452'),
          imgtrue: require('../../assets/img/circleGray.png'),
          imgfalse: require('../../assets/img/circleGreen.png'),
          show: true,
          node: 7,
        },
      ],
      showTableDiv: 0,
      title: this.$t('label_277'),
      module: 0,
      node: 0,
      dialogVisible: false,
      treeProps: {
        label: 'name',
      },
      formModel: {
        organizationId: [],
        roleName: "",
        duty: '',
        menuIds: [],
        menuNames: [],
        memberNames: [],
        memberIds: [],
        roleId: '',
        list: [],
      },
      userList: [],
      subtn: true,
      searchUser: {
        workerNumber: '',
        name: '',
        roleName: '',
        organizationName: '',
      },
      multipleSelection: [],
      width: '340px',
      qrCodeShow: false,
      ruleForm: {
        id: '',
        host: '',
        port: '',
        spssl: '',
        userName: '',
        sender: '',
        template: '',
      },
      ruleResetForm: {
        id: '',
        host: '',
        port: '',
        spssl: '',
        userName: '',
        sender: '',
        template: '',
      },
    }
  },
  watch: {},
  methods: {
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    addGroup() {
      this.radioCheck = '1';
      this.formModel.list = [];
      this.formModel.organizationId = [];
      this.dialogVisible = true;
      this.saveLoading = false;
      this.searchUser = {
        workerNumber: '',
        name: '',
        roleName: '',
        organizationName: '',
      };
      this.searchUserList();
    },
    save() {
      console.log(this.tableData);
      this.saveLoading = true;
      if (this.radioCheck == '1') {
        if (this.formModel.list.length == 0) {
          utils.messageAlert(this.$t('msg_147'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
          return false
        }
        for (var i = 0; i < this.formModel.list.length; i++) {
          var pd = true;
          for (var j = 0; j < this.tableData[this.showTableDiv].listGroup.length; j++) {
            if (this.tableData[this.showTableDiv].listGroup[j].userId == this.formModel.list[i].userId) {
              pd = false;
            }
          }
          if (pd) {
            this.tableData[this.showTableDiv].listGroup.push(this.formModel.list[i])
          }

        }
      } else {
        if (this.multipleSelection.length == 0) {
          utils.messageAlert(this.$t('msg_147'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
          return false
        }
        for (var i = 0; i < this.multipleSelection.length; i++) {
          var pd = true;
          for (var j = 0; j < this.tableData[this.showTableDiv].listGroup.length; j++) {
            if (this.tableData[this.showTableDiv].listGroup[j].type == 1) {
              if (this.tableData[this.showTableDiv].listGroup[j].userId == this.multipleSelection[i].userId) {
                pd = false;
              }
            }
          }
          if (pd) {
            this.multipleSelection[i].type = 1
            this.tableData[this.showTableDiv].listGroup.push(this.multipleSelection[i])
          }
        }
      }
      this.dialogVisible = false
      /*this.dialogVisible = false
      this.$refs.tree.setCheckedKeys([]);*/
    },
    //从属于
    loadTree(node, resolve) {
      if (node.level === 0) {
        let child = this.getChildren(0);
        child.then((res) => {
          resolve(res);
        });
      } else {
        let child = this.getChildren(node.data.id);
        child.then((res) => {
          if (res == "") {
            return resolve([]);
          } else {
            resolve(res);
          }
        });
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      this.$refs.tree.setCheckedKeys([]);
    },
    treeCheck(data, checked, indeterminate) {
      if (checked) {
        console.log(data);
        this.formModel.organizationId.push(data.id);
        this.formModel.list.push({
          userId: data.id,
          workerNumber: '',
          fullName: '',
          roleName: '',
          organizationName: data.name,
        })
      } else {
        for (var i = 0; i < this.formModel.list.length; i++) {
          if (this.formModel.list[i].userId == data.id) {
            this.formModel.list.splice(i, 1)
          }
        }
        for (var i = 0; i < this.organizationId.length; i++) {
          if (this.organizationId[i] == data.id) {
            this.organizationId.splice(i, 1)
          }
        }
      }
    },
    async getChildren(pid) {
      let childArr = [];
      await organizationTabJs.getChildren({
        pid: pid
      }).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          childArr = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return childArr;
    },
    // async getChildren2(pid) {
    // 	let childArr = [];
    // 	await menuTabJs.getByOrganization({
    // 		id: pid
    // 	}).then((response) => {
    // 		const data = response.data;
    // 		if (data.code == "1") {
    // 			childArr = data.data;
    // 		}
    // 	}).catch((response) => {
    // 		console.log(response)
    // 	})
    // 	return childArr;
    // },
    submit() {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].frequency == '0') {
          this.tableData[i].time = this.tableData[i].time0;
        } else if (this.tableData[i].frequency == '1') {
          this.tableData[i].time = this.tableData[i].time1;
        }else if(this.tableData[i].frequency == '2'){
          this.tableData[i].time = 0;
        }else if(this.tableData[i].frequency == '3'){
          this.tableData[i].time = 6;
        }


        this.tableData[i].type = this.deviceDetailMes.type
        this.tableData[i].deviceId = this.deviceDetailMes.id
      }
      file.updateWarningTime(this.tableData).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.$message({
            message: this.$t('msg_21'),
            type: 'success'
          });
          this.search();
          var x = 'Spot'
          if (this.activeNameSpot == 'pro') {
            x = 'Pro'
          } else if (this.activeNameSpot == 'xun') {
            x = 'Xun'
          } else if (this.activeNameSpot == 'bao') {
            x = 'Bao'
          }
          for (var i = 0; i < this.tableData.length; i++) {
            document.getElementById('warningBodyLeftDivShow' + x + i).setAttribute('style', 'background-color:#3fb393');
          }
          document.getElementById('warningBodyLeftDivShow' + x + 0).setAttribute('style', 'background-color:#46c7a3');
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    submit1() {
      file.updateEmail(this.ruleForm).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.$message({
            message: this.$t('msg_21'),
            type: 'success'
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    agreeChange(val) {
      console.log(val)
    },
    showTableData(index) {
      this.showTableDiv = index;
      this.tableData[index].frequency = this.tableData[index].frequency.toString();
      if (this.tableData[index].frequency == '0') {
        this.tableData[index].time0 = this.tableData[index].time;
      } else if (this.tableData[index].frequency == '1') {
        this.tableData[index].time1 = this.tableData[index].time;
      }
      var x = 'Spot'
      if (this.activeNameSpot == 'pro') {
        x = 'Pro'
      } else if (this.activeNameSpot == 'xun') {
        x = 'Xun'
      } else if (this.activeNameSpot == 'bao') {
        x = 'Bao'
      }
      for (var i = 0; i < this.tableData.length; i++) {
        document.getElementById('warningBodyLeftDivShow' + x + i).setAttribute('style', 'background-color:#3fb393');
      }
      document.getElementById('warningBodyLeftDivShow' + x + index).setAttribute('style', 'background-color:#46c7a3');
    },
    deleteTable(index) {
      if (this.tableData[index].id != null && this.tableData[index].id != '') {
        this.showTableDiv = 0;
        var x = 'Spot'
        if (this.activeNameSpot == 'pro') {
          x = 'Pro'
        } else if (this.activeNameSpot == 'xun') {
          x = 'Xun'
        } else if (this.activeNameSpot == 'bao') {
          x = 'Bao'
        }
        document.getElementById('warningBodyLeftDivShow' + x + index).setAttribute('style', 'background-color:#46c7a3');
        console.log(this.tableData);
      } else {
        this.tableData.splice(index, 1);
        this.showTableDiv = this.tableData.length - 1;
        if (index == this.showTableDiv) {
          var x = 'Spot'
          if (this.activeNameSpot == 'pro') {
            x = 'Pro'
          } else if (this.activeNameSpot == 'xun') {
            x = 'Xun'
          } else if (this.activeNameSpot == 'bao') {
            x = 'Bao'
          }
          document.getElementById('warningBodyLeftDivShow' + x + 0).setAttribute('style', 'background-color:#46c7a3');
        }

      }

    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    addWarning() {
      this.tableData.push({
        "id": "",
        "module": this.module,
        "node": this.node,
        "level": 0,
        "frequency": "1",
        "time": '',
        "time0": '',
        "time1": '',
        "valid": 0,
        "listGroup": [],
      })
    },
    handleClickSpot(tab, event) {
      // this.modelList = [];
      // this.showTableDiv = 0;
      if (tab.name == 'spot') {
        this.title = this.$t('label_277');
        this.module = 0;
        this.node = 0;
        this.modelList = [{
          title: this.$t('label_186'),
          imgtrue: require('../../assets/img/circleGray.png'),
          imgfalse: require('../../assets/img/circleGreen.png'),
          show: false,
          node: 0,
        },
          {
            title: '',
            imgtrue: require('../../assets/img/arrowsGray.png'),
            imgfalse: require('../../assets/img/arrowsGreen.png'),
            show: false,
            node: 0,
          },
          {
            title: this.$t('label_415'),
            imgtrue: require('../../assets/img/circleGray.png'),
            imgfalse: require('../../assets/img/circleGreen.png'),
            show: true,
            node: 1,
          },
          {
            title: '',
            imgtrue: require('../../assets/img/arrowsGray.png'),
            imgfalse: require('../../assets/img/arrowsGreen.png'),
            show: true,
            node: 1,
          },
          {
            title: this.$t('label_424'),
            imgtrue: require('../../assets/img/circleGray.png'),
            imgfalse: require('../../assets/img/circleGreen.png'),
            show: true,
            node: 2,
          },
          {
            title: '',
            imgtrue: require('../../assets/img/arrowsGray.png'),
            imgfalse: require('../../assets/img/arrowsGreen.png'),
            show: true,
            node: 2,
          },
          {
            title: this.$t('label_434'),
            imgtrue: require('../../assets/img/circleGray.png'),
            imgfalse: require('../../assets/img/circleGreen.png'),
            show: true,
            node: 3,
          },
          {
            title: '',
            imgtrue: require('../../assets/img/arrowsGray.png'),
            imgfalse: require('../../assets/img/arrowsGreen.png'),
            show: true,
            node: 3,
          },
          {
            title: this.$t('label_444'),
            imgtrue: require('../../assets/img/circleGray.png'),
            imgfalse: require('../../assets/img/circleGreen.png'),
            show: true,
            node: 5,
          },
          {
            title: '',
            imgtrue: require('../../assets/img/arrowsGray.png'),
            imgfalse: require('../../assets/img/arrowsGreen.png'),
            show: true,
            node: 5,
          },
          {
            title: this.$t('label_452'),
            imgtrue: require('../../assets/img/circleGray.png'),
            imgfalse: require('../../assets/img/circleGreen.png'),
            show: true,
            node: 7,
          },

        ]

      } else if (tab.name == 'pro') {
        this.title = this.$t('label_277');
        this.module = 1;
        this.node = 0;
        this.modelList = [{
          title: this.$t('label_220'),
          imgtrue: require('../../assets/img/circleGray.png'),
          imgfalse: require('../../assets/img/circleGreen.png'),
          show: false,
          node: 0,
        },
          {
            title: '',
            imgtrue: require('../../assets/img/arrowsGray.png'),
            imgfalse: require('../../assets/img/arrowsGreen.png'),
            show: false,
            node: 0,
          },
          {
            title: this.$t('label_223'),
            imgtrue: require('../../assets/img/circleGray.png'),
            imgfalse: require('../../assets/img/circleGreen.png'),
            show: true,
            node: 1,
          },
        ]
      } else if (tab.name == 'xun') {
        this.title = this.$t('label_277');
        this.module = 2;
        this.node = 0;
        this.modelList = [{
          title: this.$t('label_232'),
          imgtrue: require('../../assets/img/circleGray.png'),
          imgfalse: require('../../assets/img/circleGreen.png'),
          show: false,
          node: 0,
        },
          {
            title: '',
            imgtrue: require('../../assets/img/arrowsGray.png'),
            imgfalse: require('../../assets/img/arrowsGreen.png'),
            show: false,
            node: 0,
          },
          {
            title: this.$t('label_236'),
            imgtrue: require('../../assets/img/circleGray.png'),
            imgfalse: require('../../assets/img/circleGreen.png'),
            show: true,
            node: 1,
          },
        ]
      } else if (tab.name == 'bao') {
        this.title = this.$t('label_277');
        this.module = 3;
        this.node = 0;
        this.modelList = [{
          title: this.$t('label_240'),
          imgtrue: require('../../assets/img/circleGray.png'),
          imgfalse: require('../../assets/img/circleGreen.png'),
          show: false,
          node: 0,
        },
          {
            title: '',
            imgtrue: require('../../assets/img/arrowsGray.png'),
            imgfalse: require('../../assets/img/arrowsGreen.png'),
            show: false,
            node: 0,
          },
          {
            title: this.$t('label_244'),
            imgtrue: require('../../assets/img/circleGray.png'),
            imgfalse: require('../../assets/img/circleGreen.png'),
            show: true,
            node: 1,
          },
        ]
      }
      this.search(tab.name);
      // var x = 'Spot'
      // if (tab.name == 'pro') {
      // 	x = 'Pro'
      // } else if (tab.name == 'xun') {
      // 	x = 'Xun'
      // } else if (tab.name == 'bao') {
      // 	x = 'Bao'
      // }
      // document.getElementById('warningBodyLeftDivShow' + x + '0').setAttribute('style', 'background-color:#46c7a3');
    },
    imgShow(index) {
      for (var i = 0; i < this.modelList.length; i++) {
        this.modelList[i].show = true;
      }
      this.modelList[index].show = false;
      if (this.modelList[index].title != '') {
        if (this.modelList[index + 1] != undefined) {
          this.modelList[index + 1].show = false;

        }
        // if (this.modelList[index].title.indexOf(this.$t('label_291')) != -1 || this.modelList[index].title.indexOf(this.$t('label_294')) != -1 || this.modelList[
        //   index].title.indexOf(this.$t('label_390')) != -1) {
        //   this.title = this.modelList[index].title
        // } else {
        //   this.title = this.modelList[index].title + this.$t('label_277')
        // }


        this.node = this.modelList[index].node
      } else {
        if (this.modelList[index - 1] != undefined) {
          this.modelList[index - 1].show = false;
          // if (this.modelList[index - 1].title.indexOf(this.$t('label_291')) != -1 || this.modelList[index - 1].title.indexOf(this.$t('label_294')) != -1 ||
          //   this.modelList[index - 1].title.indexOf(this.$t('label_390')) != -1) {
          //   this.title = this.modelList[index - 1].title
          // } else {
          //   this.title = this.modelList[index - 1].title + this.$t('label_277')
          // }
          this.node = this.modelList[index - 1].node
        }

      }
      this.search();
      var x = 'Spot'
      if (this.activeNameSpot == 'pro') {
        x = 'Pro'
      } else if (this.activeNameSpot == 'xun') {
        x = 'Xun'
      } else if (this.activeNameSpot == 'bao') {
        x = 'Bao'
      }
      for (var i = 0; i < this.tableData.length; i++) {
        document.getElementById('warningBodyLeftDivShow' + x + i).setAttribute('style', 'background-color:#3fb393');
      }
      document.getElementById('warningBodyLeftDivShow' + x + '0').setAttribute('style', 'background-color:#46c7a3');
    },
    checkRisk(type) {
      var data = this.riskList.filter(function (item) {
        return item.id == type.toString();
      });
      if (data != '') {
        return data[0].val
      }
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    getDeviceMes(data) {
      this.ruleForm = this.ruleResetForm;
      this.showTableDiv = 0;
      if (data.name == this.$t('label_272')) {
        this.deviceDetailMes = {}
        this.deviceDetailMes.name = this.$t('label_272')
        this.deviceDetailMes.id = '0';
        if (this.activeNameTree == 'first') {
          this.deviceDetailMes.type = 0;
        } else {
          this.deviceDetailMes.type = 2;
        }
        this.search()
      } else {
        this.deviceDetailMes = data;
        if (this.activeNameTree == 'first') {
          this.deviceDetailMes.type = 0;
        } else {
          this.deviceDetailMes.type = 2;
          if (data.hierarchy != null && data.hierarchy != '') {
            this.selectEmail(data.hierarchy);
          }
        }
        this.search()
      }
    },

    getRiskList() {
      file.getByDictIdALL({dictId: 7, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.riskList = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getRiskList().then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.riskList = data.data
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },

    handleClickTree(tab, event) {
      this.deviceDetailMes = {}
      this.deviceDetailMes.name = this.$t('label_272')
      this.deviceDetailMes.id = '0';
      if (tab.name == 'first') {
        this.deviceDetailMes.type = 0;
      } else {
        this.deviceDetailMes.type = 2;
      }
      this.search()
    },
    search(name) {
      var param = {
        type: this.deviceDetailMes.type,
        deviceId: this.deviceDetailMes.id,
        module: this.module,
        node: this.node,
      }
      this.tableData = [];
      this.showTableDiv = 0;
      file.selectWarningTime(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          if (data.data.length <= 0) {
            this.tableData = [{
              "id": "",
              "module": this.module,
              "node": this.node,
              "level": 0,
              "frequency": "1",
              "time": '',
              "time0": '',
              "time1": '',
              "valid": 0,
              "listGroup": [],
            }]
          } else {
            for (var i = 0; i < data.data.length; i++) {
              if (this.tableData[i] == undefined) {
                this.tableData.push({
                  "id": "",
                  "module": this.module,
                  "node": this.node,
                  "level": 0,
                  "frequency": "1",
                  "time": '',
                  "time0": '',
                  "time1": '',
                  "valid": 0,
                  "listGroup": [],
                })
              }
              this.tableData[i].id = data.data[i].id
              this.tableData[i].module = data.data[i].module
              this.tableData[i].node = data.data[i].node
              this.tableData[i].level = data.data[i].level
              this.tableData[i].time = data.data[i].time
              this.tableData[i].valid = data.data[i].valid
              this.tableData[i].listGroup = data.data[i].listGroup
              this.tableData[i].frequency = data.data[i].frequency.toString();
              if (this.tableData[i].frequency == '0') {
                this.tableData[i].time0 = this.tableData[i].time;
              } else if (this.tableData[i].frequency == '1') {
                this.tableData[i].time1 = this.tableData[i].time;
              }else if(this.tableData[i].frequency == '2'){
                this.tableData[i].time = 0;
              }else if(this.tableData[i].frequency == '3'){
                this.tableData[i].time = 6;
              }
            }


          }
          document.getElementById('warningBodyLeftDivShowSpot0').setAttribute('style', 'background-color:#46c7a3');
          document.getElementById('warningBodyLeftDivShowPro0').setAttribute('style', 'background-color:#46c7a3');
          document.getElementById('warningBodyLeftDivShowXun0').setAttribute('style', 'background-color:#46c7a3');
          document.getElementById('warningBodyLeftDivShowBao0').setAttribute('style', 'background-color:#46c7a3');
        }
        if (name == 'pro' || name == 'xun' || name == 'bao') {
          this.tableData[this.showTableDiv].frequency = '3'
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    searchUserList() {
      file.selectWarningUser(this.searchUser).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.userList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    showBtn() {
      this.qrCodeShow = !this.qrCodeShow;
      if (this.qrCodeShow) {
        this.width = "0px";
      } else {
        this.width = "340px";
      }
    },
    selectEmail(param) {
      file.selectEmail(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.ruleForm = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    }
  },
  created() {
    this.search();
    this.getRiskList();
    this.MenuRoleList = this.$store.getters.getMenu;
  }
}
</script>

<style>
.tab .el-tabs__header {
  padding-left: 0px;
}

.tab .el-tab-pane {
  width: 100%;
  height: 100%;
}

.allDiv {
  width: 100%;
  height: 100%;
  background-color: #efefef;
}

.warningleft {
  width: 200px;
  height: 100%;
  float: left;
}

.warningright {
  width: calc(100% - 200px);
  height: 100%;
  float: left;
  padding: 20px;
}

.warningright1 {
  width: 100%;
  height: 100%;
  float: left;
  padding: 20px;
}

.modeldiv {
  width: 100%;
  height: calc(100% / 13);
  float: left;
  display: table-cell;
  text-align: right;
}

.modelImg {
  width: 25px;
  height: 25px;
  margin: 0 30px 0 20px;
  vertical-align: -webkit-baseline-middle;
}

.modelspan {
  font-size: 17px;
  font-weight: 600;
  line-height: 100%;
  vertical-align: -webkit-baseline-middle;
}

.RightDiv_topspan {
  font-size: 15px;
  font-weight: 600;
  line-height: 100%;
}

.modelImgarrows {
  width: 25px;
  height: 35px;
  margin: 0 30px 0 20px;
  vertical-align: -webkit-baseline-middle;
}

.warningBody {
  width: 100%;
  height: 100%;
  border: 1px solid #3fb393;
  border-radius: 0px 5px 5px 5px;
  background-color: #e3f7f0;
}

.warningBodyLeftDiv {
  width: 87px;
  height: 100%;
  float: left;
  overflow: auto;
}

.warningBodyLeftDivShow {
  width: 70px;
  height: 210px;
  background-color: #3fb393;
  position: relative;
  display: flex;
  justify-content: center;
}

.warningBodyLeftDivAdd {
  width: 70px;
  height: 135px;
  float: left;
  border: 1px solid #3fb393;
  border-left: 0px;
  background-color: #e3f7f0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.warningBodyRightDiv {
  width: calc(100% - 87px);
  height: 100%;
  float: left;
  padding: 15px;
}

.warningBodyRightDivTitle {
  font-size: 17px;
  font-weight: 600;
  line-height: 100%;
  vertical-align: -webkit-baseline-middle;
  margin: 20px 10px;
}

.warningBodyRightDivLabel {
  font-size: 17px;
  font-weight: 600;
  line-height: 100%;
  vertical-align: -webkit-baseline-middle;
  margin: 10px 10px;
}

.warningBodyRightDivInput {
  font-size: 17px;
  font-weight: 600;
  line-height: 100%;
  vertical-align: -webkit-baseline-middle;
  margin: 10px 10px;
  width: 500px;
}

.warningspan {
  width: 20px;
  font-size: 20px;
  word-wrap: break-word;
  letter-spacing: 0px;
  color: #FFFFFF;
  padding-top: 10px;
}

.Addimg {
  width: 25px;
  height: 25px;
}

.RightDiv_top {
  margin-top: 20px;
  width: 100%;
  height: 80px;
  background-color: #ffffff;
  padding: 5px 10px 5px 10px;
}

.RightDiv_top .el-input__inner {
  height: 30px;
}

.RightDiv_table {
  margin-top: 20px;
  width: 100%;
  height: calc(100% - 200px);
}

.RightDiv_button {
  width: 100%;
  height: 30px;
  padding-left: 0px;
  margin: 10px auto;
}

.subtract {
  width: 20px;
  height: 20px;
}

.btn {
  width: 92px;
  height: 34px;
  background: #3fb393;
  color: #ffffff;
  border-radius: 4px;
  text-align: center;
  margin: 0 auto;
  border: 0;
}

.useradd {
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
}

.useraddspan {
  font-size: 17px;
  font-weight: 600;
  line-height: 100%;
  line-height: 30px;
  margin-right: 15px;
}

.dialogBoxWarning {
  height: 600px;
}

.dialogBoxWarning .el-dialog__body {
  height: calc(100% - 120px);
}

.dialogBoxWarning .dialogBoxMes {
  height: calc(100% - 50px);
}

.dialogBoxWarning .dialogMes {
  height: 100%;
}

.delete {
  position: absolute;
  top: 0px;
  right: 0px;
  cursor: pointer;
}

.right-showbtn-qrcode-background {
  /* position: absolute; */
  width: 10px;
  height: 80px;
  background-color: #9c9c9c;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin: auto;
}

.right-showbtn {
  width: 10px;
  height: 100%;
  display: flex;
  position: relative;
  z-index: 100000;
}
</style>



// WEBPACK FOOTER //
// src/pages/basic/warningTimePage.vue